module.exports = __webpack_public_path__ + "img/1551627544.bba6d4f9.jpg";